import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchFacets as RSKSearchFacets } from '@uncinc/react-searchkit';

import { SCREEN_NORMAL } from '../../../config/constants';
import Button from '../../Button';
import SearchFilterDialog from '../FilterDialog';

import './style.scss';

export interface SearchFacetsProps {
  title?: string;
  hideTitle?: boolean;
  forceDialog?: boolean;
  className?: string;
  forceList?: boolean;
}

const SearchFacets: React.FC<SearchFacetsProps> = (props) => {
  const {
    title,
    hideTitle,
    forceDialog = false,
    children,
    className,
    forceList = false,
  } = props;

  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const classNames = c('SearchFacets', className);

  return (
    <div className={classNames}>
      {(forceDialog || width < SCREEN_NORMAL) && !forceList ? (
        <SearchFilterDialog
          title={title || t('components.search.facets.title')}
          openButtonProps={{
            iconPosition: 'left',
          }}
        >
          {({ closeDialog }) => (
            <RSKSearchFacets
              className="SearchFacets__facets"
              autoSubmit={false}
              onSubmit={() => closeDialog()}
              // eslint-disable-next-line react/no-unstable-nested-components
              submitButton={(buttonProps) => (
                <div className="SearchFacets__submit">
                  <Button {...buttonProps} />
                </div>
              )}
            >
              {children}
            </RSKSearchFacets>
          )}
        </SearchFilterDialog>
      ) : (
        <>
          {!hideTitle && (
            <h2 className="SearchFacets__title mb-8">
              {title || t('components.search.facets.title')}
            </h2>
          )}

          <RSKSearchFacets className="SearchFacets__facets">
            {children}
          </RSKSearchFacets>
        </>
      )}
    </div>
  );
};

export default SearchFacets;
